import React, { useState } from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import { useAccount } from 'wagmi'; // Only use the account information from wagmi
import SearchBar from '../components/SearchBar.tsx';
import CreateCommunityModal from '../components/FormModals/CreateCommunityModal.tsx';
import MintPostModal from '../components/FormModals/MintPostModal.tsx';
import { useNavigate } from 'react-router-dom';
import '../App.css';  // Import your custom CSS file

function Home() {
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showMintPost, setShowMintPost] = useState(false);

    // Use wagmi's useAccount to get the connected wallet address and connection status
    const { address, isConnected } = useAccount();

    const navigate = useNavigate();

    const handleSearch = (type, value) => {
        navigate(`/search-results?type=${encodeURIComponent(type)}&value=${encodeURIComponent(value)}`);
    };

    return (
        <div className="d-flex justify-content-center align-items-center " style={{marginTop:"50px"}}>
            <Card className="home-card">
                <Card.Body className="d-flex flex-column align-items-center">
                    <Card.Title style={{ fontSize: "2rem", marginTop: "1vh", color: "white" }}>
                        Welcome to <span style={{ fontSize: "2.1rem", fontWeight: "bold" }}> tg</span>ether
                    </Card.Title>
                    <Card.Subtitle className="mb-4">A Decentralized Consensus Platform</Card.Subtitle>

                    {/* Search Bar */}
                    <SearchBar
                        initialSearchType=""  // Empty initial values for the home page
                        initialSearchValue=""
                        onSearch={handleSearch}
                    />

                    {/* Buttons for Creating Community and Minting Post */}
                    <Row style={{ marginTop: "15px" }}>
                        <Col>
                            <Button variant="info" className="ml-2" onClick={() => setShowCreateModal(true)}>Create Community</Button>
                        </Col>
                        <Col>
                            <Button variant="info" className="ml-2" style={{ padding: "20px" }} onClick={() => setShowMintPost(true)}>Mint Post</Button>
                        </Col>
                    </Row>

                    {/* Modals for Creating Community and Minting Post */}
                    <MintPostModal show={showMintPost} setShow={setShowMintPost} />
                    <CreateCommunityModal show={showCreateModal} setShow={setShowCreateModal} />

                    {/* Information about Version */}
                    <Card.Subtitle style={{ width: '80%', marginTop: "2vh" }} className="mb-4">
                        *Search Version 1.0 will be improved with Graph Integration
                    </Card.Subtitle>

                    {/* Display Account Info */}
                    {isConnected ? (
                        <Card.Text style={{ marginTop: '2vh' }}>
                            Connected to {address ? address.slice(0, 6) + '...' + address.slice(-4) : 'Wallet'}
                        </Card.Text>
                    ) : (
                        <Card.Text style={{ marginTop: '2vh', color: 'red' }}>
                            Please connect your wallet to interact with the platform.
                        </Card.Text>
                    )}
                </Card.Body>
            </Card>
        </div>
    );
}

export default Home;
